import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, set } from "firebase/database";

let AsyncStorage = null;
try {
  AsyncStorage = require('@react-native-async-storage/async-storage').default;
} catch (e) {}

const CACHED_SETTINGS_KEY = 'cached_settings';

export const fetchSettings= () => async (dispatch) => {
  if (!firebase) return;

  const {
    settingsRef
  } = firebase;

  if (AsyncStorage) {
    try {
      const raw = await AsyncStorage.getItem(CACHED_SETTINGS_KEY);
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          dispatch({
            type: FETCH_SETTINGS_SUCCESS,
            payload: cached,
          });
        }
      }
    } catch (e) {}
  }

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });
  onValue(settingsRef, (snapshot) => {
    if (snapshot.val()) {
      if (AsyncStorage) {
        AsyncStorage.setItem(CACHED_SETTINGS_KEY, JSON.stringify(snapshot.val())).catch(() => {});
      }
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: snapshot.val(),
      });
    } else {
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: "Unable to fetch database and settings.",
      });
    }
  });
};

export const editSettings = (settings) => (dispatch) => {
  const {
    settingsRef
  } = firebase;
  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });
  set(settingsRef, settings);
  alert(store.getState().languagedata.defaultLanguage.updated);
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};
